import {GlobalVariables} from "../GlobalVariables";
import {gsap, Observer, ScrollTrigger} from "../LibrariesImport";

export default class BlockKeyNumbers {
	static init() {
		this.blocks = document.querySelectorAll(".block-key-numbers");
		this.blocks.forEach( block => {

			ScrollTrigger.create({
				trigger: block,
				once: true,
				onEnter: () => {
					this.numbers = block.querySelectorAll('.counter');
					this.numbers.forEach(number => {
						let target = Number(String(number.dataset.end).replace(',', '.'));
						let start = 0;
						let increment = target / (2000 / 16); // environ 60 FPS
						let counter = setInterval(() => {
							start += increment;
							if (start >= target) {
								start = target;
								clearInterval(counter);
							}
							number.textContent = Number(start).toFixed(1).replace('.', ',').replace(',0', '');
						}, 16);
					});
				}
			});
		});
	}

}
